import { useState, useEffect } from "react";
import { Button, Box, TextField } from "@mui/material";
import { UseSmell } from "./UseSmell";
import { useNavigate, useLocation } from "react-router-dom";
import ProgressCom from "../../components/ProgressCom";
import Detail from "../../main/detail/Detail";
import { rsGotoLast, rsProgress, rsActiveMenu } from "../../RecoilStates";
import { useRecoilState } from "recoil";
import useBreakpoints from "../../hooks/useBreakpoints";

function EditSmell(props) {
  const [msActiveMenu, setMsActiveMenu] = useRecoilState(rsActiveMenu);
  const [progress, setProgress] = useRecoilState(rsProgress);
  const navigate = useNavigate();
  const location = useLocation();
  const [brand, setBrand] = useState();
  const { getSmellByID, validate, updateSmell } = UseSmell();
  const { isSmall } = useBreakpoints();

  useEffect(() => {
    if (location.state && location.state.id) {
      getSmellByID(location.state.id, (brandRes) => {
        setState(brandRes);
      });
    }
  }, []);

  const [state, setState] = useState({
    id: undefined,
    name: undefined,
  });

  const [errorState, setErrorState] = useState({
    name: false,
  });

  return (
    <Detail
      breadChilds={{
        title: "اطلاعات پایه",
        childs: [
          { name: msActiveMenu.pageTitle, url: "/productscent" },
          { name: "ویرایش رایحه", url: "/productscent/editproductscent" },
        ],
      }}
    >
      {!brand ? (
        <Box display="grid" gridTemplateColumns="repeat(12, 1fr)" gap={3}>
          <Box gridColumn={isSmall ? "span 12" : "span 3"}>
            <TextField
              fullWidth
              value={state.name ? state.name : ""}
              error={errorState.name}
              label="نام "
              size="small"
              variant="outlined"
              onChange={(evt) => {
                setState({ ...state, name: evt.target.value });
              }}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Box>
          {!isSmall && <Box gridColumn="span 9"></Box>}
          <Box
            gridColumn={isSmall ? "span 12" : "span 3"}
            sx={{ display: "flex", justifyContent: "flex-end" }}
          >
            <Button
              sx={{ mr: 2, width: "100px" }}
              variant="contained"
              color="secondary"
              onClick={() => {
                if (validate(state, setErrorState) == 200) {
                  setProgress(true);
                  updateSmell(state, () => {
                    navigate("/productscent", {
                      state: { ...location.state, isBack: true },
                      replace: true,
                    });
                  });
                }
              }}
            >
              ثبت
            </Button>
            <Button
              sx={{ width: "100px" }}
              variant="outlined"
              color="secondary"
              onClick={() => {
                navigate("/productscent", {
                  state: { ...location.state, isBack: true },
                  replace: true,
                });
              }}
            >
              بازگشت
            </Button>
          </Box>
        </Box>
      ) : (
        <ProgressCom></ProgressCom>
      )}
    </Detail>
  );
}

export default EditSmell;
